export default {
  resetPlvl: 'reset_plvl',
  loadingFlashcardAnswer: 'loading_flashcard_answer',
  changePlvlManually: 'change_plvl_manually',
  flashcardArchived: 'flashcard_archived',
  flashcardRedirectLoading: 'flashcard_redirect_loading'
}
